import React, { FC } from 'react';

import { useTranslation } from 'next-i18next/pages';

import { TranslationNamespace } from '@/i18n';

import styles from './WhoAreWeSection.module.scss';

export const WhoAreWeSection: FC = () => {
	const { t } = useTranslation(TranslationNamespace.Marketing);
	return (
		<section className={styles.whoAreWe}>
			<div className={styles.title}>{t('about-us-container.who-are-we')}</div>
			<div className={styles.aboutFishplace}>
				{t(
					'about-us-container.moi-fish-place-llc-will-unite-players-in-the-fishing-industry-on-a-singl',
				)}
			</div>
			<iframe
				title={t('about-us-container.platform-promo-video')}
				className={styles.video}
				style={{ borderRadius: '24px' }}
				src="https://rutube.ru/play/embed/fd1666029793fa94f6cd5f6d0b726845/"
				frameBorder="0"
				allow="clipboard-write; autoplay"
				allowFullScreen
			/>
		</section>
	);
};
